module.exports = __webpack_public_path__ + "prod/1.42.2/img/success_exam.7048e460.png";